









































































































































































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

import { formatCurrency } from "@/utility/Formatter";

// Vue Components
import MultiCurrencyCashDetailsListTable from "@/views/App/Components/MultiCurrencyCashDetailsListTable.vue";
import TransactionPropsList from "@/components/PropsLists/TransactionPropsList.vue";
import BanknoteSerialNumberCard from "./BanknoteSerialNumberCard.vue";
import InstallationTreePathWithResumeDialog from "@/components/InstallationTreePathWithResumeDialog.vue";
import { TransactionTypeEnum } from "@/model/data/enums/TransactionTypeEnum";

export default Vue.extend({
    components: {
        TransactionPropsList,
        MultiCurrencyCashDetailsListTable,
        BanknoteSerialNumberCard,
        InstallationTreePathWithResumeDialog,
    },
    data() {
        return {
            noBanknoteSerialTransactions: [
                TransactionTypeEnum.ManualEmpty,
                TransactionTypeEnum.ManualDeposit,
                TransactionTypeEnum.VirtualSafeDeposit,
                TransactionTypeEnum.VirtualSafeWithdrawal,
            ],
            categoryHeaders: [
                {
                    text: this.$t("cash_report.categoryName"),
                    value: "name",
                },
                {
                    text: this.$t("common.amount"),
                    value: "amount",
                },
            ],
            ticketHeaders: [
                {
                    value: "icon",
                    sortable: false,
                },
                {
                    text: this.$t("common.type"),
                    value: "type",
                },
                {
                    text: this.$t("common.amount"),
                    value: "amount",
                    align: "center",
                },
                {
                    text: this.$t("common.quantity"),
                    value: "quantity",
                    align: "center",
                },
                {
                    text: this.$t("common.total"),
                    value: "total",
                    align: "right",
                },
            ],
            chequeHeaders: [
                {
                    value: "icon",
                    sortable: false,
                },
                {
                    text: this.$t("cash_report.codeline"),
                    value: "codeline",
                },
                {
                    text: this.$t("common.amount"),
                    value: "amount",
                    align: "right",
                },
            ],
            manualTransaction: [TransactionTypeEnum.ManualEmpty, TransactionTypeEnum.ManualDeposit],
            envelopeHeaders: [
                {
                    value: "icon",
                    sortable: false,
                },
                {
                    text: this.$t("cash_report.envelopeId"),
                    value: "envelopeId",
                },
                {
                    text: this.$t("cash_report.user_id"),
                    value: "userId",
                },
                {
                    text: this.$t("common.transactionId"),
                    value: "nop",
                },
            ],
        };
    },
    props: {
        transaction: {},
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        extraFeaturesTableHeaders() {
            return [
                { text: "Key", value: "key" },
                { text: "Value", value: "value" },
            ];
        },

        extraFeaturesTableItems() {
            let result = [];
            if (this.transaction.extraFeatures) {
                Object.keys(this.transaction.extraFeatures).forEach((k) => {
                    result.push({
                        key: k,
                        value: this.transaction.extraFeatures[k],
                    });
                });
            }
            return result;
        },
        ticketTotal() {
            if (this.transaction && this.transaction.tickets && this.transaction.tickets.length > 0) {
                let totalByCurr = new Map<string, number>();
                this.transaction.tickets.forEach((ticket) => {
                    if (!totalByCurr.has(ticket.currency)) totalByCurr.set(ticket.currency, ticket.amount * ticket.quantity);
                    else totalByCurr.set(ticket.currency, totalByCurr.get(ticket.currency) + ticket.amount * ticket.quantity);
                });
                return totalByCurr;
            }
            return [];
        },
        ticketTotalQuantity() {
            if (this.transaction && this.transaction.tickets && this.transaction.tickets.length > 0) {
                return this.transaction.tickets.reduce((partialSum, ticket) => partialSum + ticket.quantity, 0);
            }
            return 0;
        },
        chequeTotal() {
            if (this.transaction && this.transaction.cheques && this.transaction.cheques.length > 0) {
                let totalByCurr = new Map<string, number>();
                this.transaction.cheques.forEach((cheque) => {
                    if (!totalByCurr.has(cheque.currency)) totalByCurr.set(cheque.currency, cheque.amount);
                    else totalByCurr.set(cheque.currency, totalByCurr.get(cheque.currency) + cheque.amount);
                });
                return totalByCurr;
            }
            return [];
        },
        transactionTotal() {
            if (this.transaction && this.transaction.total && !this.manualTransaction.includes(this.transaction.type)) {
                let transactionTotal = [];
                this.transaction.total.forEach((total) => {
                    if (this.transaction.detail.filter((a) => a.denomination.currency == total.key).length > 0) transactionTotal.push(total);
                });
                return transactionTotal;
            }
            return this.transaction.total;
        },
        showEnvelopesInfo() {
            return this.transaction.type == TransactionTypeEnum.ManualEmpty && this.transaction.envelopesInfo && this.transaction.envelopesInfo.length;
        },
        manualDepositAmountHeaders() {
            let manualDepositAmountHeaders = [];
            if (this.$vuetify.breakpoint.smAndUp)
                manualDepositAmountHeaders.push({
                    value: "icon",
                    sortable: false,
                    width: "10%",
                });
            manualDepositAmountHeaders.push(
                {
                    text: this.$t("common.type"),
                    value: "type",
                },
                {
                    text: this.$t("common.total"),
                    value: "total",
                    align: "right",
                }
            );
            return manualDepositAmountHeaders;
        },
    },
    methods: {
        formatCurrency,
        getDenominationTotalValue(cur, den) {
            const denominationValue = this.transaction.detail.denominations.find((v) => v.currency == cur && den.split(" ")[1] === v.valueString).Value;

            return this.transaction.detail.count[den] * denominationValue;
        },
        showCurrencyCard(curr) {
            return this.transaction.detail.filter((a) => a.denomination.currency == curr).length > 0;
        },
    },
});
